<template>
    <div class="animated fadeIn">
      <div class="row">
      </div>
      <Tables ref="tableGrid"
              :columns="columns"
              :showSearch="false"
              :showReload="false"
              :showTipFooter="false"
              v-on:Search="onShowSearch"
              v-on:Load="onLoad"
              :showPaging="false"
              v-on:Reload="onLoad">
        <template slot="table-header-buttons">
          <a href="javascript:void(0);" v-b-tooltip.hover :title="'Exportar'" @click="onExportExcel">
            <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
          </a>
        </template>
        <tr v-for="obj in objList" v-bind:key="obj.id">
          <template>
            <div @click="openAttachModalMessages(obj.conversationId, obj.provider, obj.identifierProvider)">
              <TableColumn :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.protocolo ? obj.protocolo : 'NÃO POSSUI'" />
            </div>
            <TableColumn :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.dataFinalizacao ? formatDateAndTime(obj.dataFinalizacao) : 'NÃO POSSUI'" />
            <TableColumn :IsText="true" :status="obj.inative ? 0 : 1" :value="formatCondicao(obj.condicao)" />
          </template>
        </tr>
      </Tables>
      <!-- <div class="pagination-controls">
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-center">
              <li class="page-item">
                <a @click="goToFirstPage" :disabled="filters.page <= 1" class="page-link" href="#">Primeira</a>
              </li>
              <li class="page-item"><a @click="previousPage" :disabled="filters.page <= 1" class="page-link" href="#">Anterior</a></li>
              <li v-for="page in getPageRange()" :key="page" :class="['page-item', { 'active': page === filters.page }]">
               <a @click="goToPage(page)" class="page-link" href="#">{{ page }}</a>
              </li>
              <li class="page-item"><a @click="nextPage" :disabled="filters.page >= totalPages" class="page-link" href="#">Próximo</a></li>
              <li class="page-item">
                <a @click="goToLastPage" :disabled="filters.page >= totalPages" class="page-link" href="#">Última</a>
              </li>
              <ul class="pagination justify-content-center">
                <span class="page-link">
                  {{ filters.page }} de {{ totalPages }}
                </span>
              </ul>
            </ul>
          </nav>
        </div> -->

      <SidebarSearch @search="onSearch" />
      <MessagesModal ref="messagesModal" :btnRelatorio="true" />
    </div>
  </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import ReportAtendimentoRepository from '@/shared/http/repositories/crm/reportAtendimento.js'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import PARepository from '@/shared/http/repositories/configurations/pa.js'

import { NxDataGrid, NxDataGridColumn, NxDataGridItem } from '@/components/nexum/components'
import SidebarSearch from '@/views/private/atendimento/relatorios_atendimento/search/SidebarRelatorioAtendimento.vue'
import MessagesModal from '@/views/private/atendimento/components/modal/MessageModals.vue'

export default {
  name: 'ReportAtendimento',
  mixins: [ActionsForm],
  props: {
    person: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      data: null,
      form: null,
      totalPages: null,
      localData: [],
      filters: {
        identifier: this.person,
        status: 'Finalizado',
        page: 1,
        pageSize: 10
      },
      columns: [],
      columnsOpt: [
        'PROTOCOLO',
        'DATA DE FECHAMENTO',
        'CONDIÇÃO DE FINALIZAÇÃO'
      ],
      selectedCard: null
    }
  },
  components: {
    NxDataGrid,
    NxDataGridColumn,
    NxDataGridItem,
    SidebarSearch,
    MessagesModal
  },
  mounted () {
    console.log('Valor de person:', this.person)
  },
  methods: {
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.getPages()
        this.onLoadAll()
      })
    },
    openAttachModalMessages (conversationId, provider, identifierProvider) {
      this.$refs.messagesModal.openModal(conversationId, provider, identifierProvider)
    },
    onLoad () {
      this.setColumns()
      this.getPages()
      this.onLoadAll()
    },
    load (params) {
      return ReportAtendimentoRepository.GetAll(this.filters, { params })
    },
    clearData () {
      this.localData = []
    },
    getPageRange () {
      const totalPages = this.totalPages || 1
      const range = 5
      let startPage = Math.max(1, this.filters.page - range)
      let endPage = Math.min(totalPages, this.filters.page + range)

      if (endPage - startPage < range * 2) {
        if (startPage === 1) {
          endPage = Math.min(totalPages, startPage + range * 2)
        } else {
          startPage = Math.max(1, endPage - range * 2)
        }
      }

      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
    },

    goToPage (page) {
      this.filters.page = page
      this.clearData()
      this.onLoadAll()
    },

    previousPage () {
      if (this.filters.page > 1) {
        this.filters.page--
        this.clearData()
        this.onLoadAll()
      }
    },

    nextPage () {
      if (this.filters.page < this.totalPages) {
        this.filters.page++
        this.clearData()
        this.onLoadAll()
      }
    },
    goToFirstPage () {
      if (this.filters.page !== 1) {
        this.filters.page = 1
        this.clearData()
        this.onLoadAll()
      }
    },
    goToLastPage () {
      if (this.filters.page !== this.totalPages) {
        this.filters.page = this.totalPages
        this.clearData()
        this.onLoadAll()
      }
    },
    async getPages () {
      const requestConfigPages = {
        status: this.filters.status,
        operatorId: this.filters.operadores,
        startDate: this.filters.dataInicial ? new Date(this.filters.dataInicial).toISOString() : null,
        endDate: this.filters.dataFinal ? new Date(this.filters.dataFinal).toISOString() : null,
        typeFinalization: this.filters.tipoFinalizacao,
        identifier: this.filters.numeroTelefone
      }

      return AtendimentoRepository.GetPages(this.filters, requestConfigPages)
        .then(response => {
          const { status, data } = response

          if (status === 200) {
            this.countsConversation = data.count
            this.totalPages = Math.ceil(this.countsConversation / this.filters.pageSize)
          }
        })
    },
    onLoadAll () {
      loading.push()

      const requestConfig = {
        params: {
          status: this.filters.status,
          operatorId: this.filters.operadores,
          startDate: this.filters.dataInicial ? new Date(this.filters.dataInicial).toISOString() : null,
          endDate: this.filters.dataFinal ? new Date(this.filters.dataFinal).toISOString() : null,
          page: this.filters.page,
          pageSize: this.filters.pageSize,
          typeFinalization: this.filters.tipoFinalizacao,
          identifier: this.filters.numeroTelefone,
          fetchImages: false
        }
      }
      ReportAtendimentoRepository.GetAll(this.filters, requestConfig)
        .then((response) => {
          const responseCerto = {
            data: { content: response.data, totalElements: response.data.length, number: 0, pagingLimit: this.filters.pageSize },
            status: 200
          }
          this.onResultGrid(responseCerto)
        })
        .catch(this.onException)
        .finally(() => loading.close())
    },
    onLoadPAs () {
      PARepository.GetAll()
        .then((response) => {
          let result = response.data.content.map((x) => ({ value: x.numero, text: x.descricao }))
          this.form.numeroPA.listOptions = result
        })
        .catch(this.onException)
    },
    onExportExcel () {
      loading.push()
      ReportAtendimentoRepository.ExportAllCardsReport(this.filters)
        .then((response) => {
          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + 'RelatorioAtendimento.xlsx'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)
        .finally(() => loading.close())
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    setColumns () {
      this.columns = []
      for (let i = 0; i < this.columnsOpt.length; i++) {
        this.columns.push(this.columnsOpt[i])
      }
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    },
    reloadGrid () {
      this.onLoad()
    },
    formatDateAndTime (rawDate) {
      const date = new Date(rawDate)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month}/${year} às ${hours}:${minutes}`
    },
    onLimitCarac (text) {
      return text.length > 100 ? text.substring(0, 100).concat('...') : text
    },
    formatTime (milliseconds) {
      const hours = Math.floor(milliseconds / 3600000)
      const minutes = Math.floor((milliseconds % 3600000) / 60000)
      const seconds = Math.floor((milliseconds % 60000) / 1000)

      let timeString = ''

      if (hours > 0) {
        timeString += `${hours} hora${hours > 1 ? 's' : ''} `
      }

      if (minutes > 0 || hours > 0) {
        timeString += `${minutes} minuto${minutes > 1 ? 's' : ''} `
      }

      if (seconds > 0 || minutes > 0 || hours > 0) {
        timeString += `${seconds} segundo${seconds > 1 ? 's' : ''}`
      }

      return timeString.trim()
    },
    formatCondicao (condicao) {
      if (condicao === null) {
        return 'NEUTRO'
      } else if (condicao) {
        return 'POSITIVO'
      } else {
        return 'NEGATIVO'
      }
    },
    pad (number) {
      return number < 10 ? '0' + number : number
    },
    padMilliseconds (milliseconds) {
      return milliseconds < 100
        ? milliseconds < 10
          ? '00' + milliseconds
          : '0' + milliseconds
        : milliseconds
    }
  }
}
</script>

  <style>
  .popover-header {
    background-color: #04a791;
    color: #eceff1;
  }
  .pagination .page-item.active .page-link {
    background-color: #04a791;
    color: #ffffff;
  }

  </style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/protocols/Protocols.vue